class PlannedTimeService {

    /**
     * @private {PlannedTimeRepository}
     */
    _repo;

    /**
     * @private {ReactiveArray<PlannedTime>}
     */
    _entries;

    /**
     * @private {Date}
     */
    _start;

    /**
     * @private {Date}
     */
    _end;

    /**
     * @param {PlannedTimeRepository} repo
     * @param {ReactiveArray<PlannedTime>} entries
     */
    constructor(repo, entries) {
        this._repo = repo;
        this._entries = entries;
    }

    /**
     * @return {Date[]}
     */
    getTimeRange() {
        if (!this._start || !this._end) {
            return [];
        }
        return [this._start, this._end];
    }

    /**
     * @param {Date} start
     * @param {Date} end
     */
    setTimeRange(start, end) {
        this._start = start;
        this._end = end;

        this._repo.getDuring(start, end).then(plannedTimes => {
            this._entries.fill(...plannedTimes);
        });

    }

}

export default PlannedTimeService;